@if (initialized && kpiHeaderDto) {

    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/pc/config"
    ></kpi-header>


}